export const PROMO_CONFIG = {
  enabled: true,
  whatsappNumber: "6288293642972",
  showOncePerSession: true,
  delay: 4000, // ms
  voucherCode: "SELAMATBERGABUNG10",
  maxDiscount: "Rp 50.000",
};
